
$(document).ready(function() {
    var resizeTimer;

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            updateFullWidthElements();
        }, 200);
    });

    updateFullWidthElements();
});

function updateFullWidthElements(screenWidth) {
    var screenWidth = $(window).width();

    $('.full-width').each(function(index, value) {
        $(this).css('width', screenWidth + 'px');
        $(this).css('margin-left', -(screenWidth / 2) + 'px');
        $(this).trigger("full-width-resize");
    });
}